import { routing } from "./routing";

export function localizedPath(locale: string, pathname: string): string {
  const normalizedPath = stripLocalePrefix(pathname);
  if (locale === routing.defaultLocale) return normalizedPath;
  return normalizedPath === "/" ? `/${locale}` : `/${locale}${normalizedPath}`;
}

export function loginPath(locale: string, returnTo: string): string {
  return `${localizedPath(locale, "/login")}?${new URLSearchParams({
    returnTo: localizedPath(locale, returnTo),
  }).toString()}`;
}

function stripLocalePrefix(pathname: string): string {
  for (const locale of routing.locales) {
    const prefix = `/${locale}`;
    if (pathname === prefix) return "/";
    if (pathname.startsWith(`${prefix}/`)) return pathname.slice(prefix.length);
  }
  return pathname;
}
